export const css = {
	root: 'YrQcAxNh',
	output: '_2DAuhldI',
	bar: '_3uwYkyto',
	progress: '_2kVVgncB',
	' _key': 'afcpe-theme/afcpe/micro/dojo/progress'
};

export default css;
